import req from "../http";

const opening = {
  // 取得 職缺
  getOpening(params) {
    return req("get", "/Recruitment/GetOpening", params);
  },
  // 排序 職缺
  sortOpening(params) {
    return req("post", "/Recruitment/Ordering", params);
  },
};

export default opening;